import { render } from "./App.vue?vue&type=template&id=3f1ef7de"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3f1ef7de&lang=css"
script.render = render

export default script